module.exports = __webpack_public_path__ + "img/double-arrow-left.703d69e0.svg";